(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/my-information-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/my-information-panel.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const getCustomerBankAccounts = svs.myProfile.react.store.pd.actions.getCustomerBankAccounts;
const _svs$myProfile$react$ = svs.myProfile.react.pages.myInformation.myInformation.components,
  InfoPair = _svs$myProfile$react$.InfoPair,
  BankAccountCard = _svs$myProfile$react$.BankAccountCard;
const MobileCard = svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileCard;
const EmailCard = svs.myProfile.react.pages.myInformation.myInformation.email.EmailCard;
const _svs$myProfile$consta = svs.myProfile.constants.thunkStatus,
  FULFILLED = _svs$myProfile$consta.FULFILLED,
  REJECTED = _svs$myProfile$consta.REJECTED;
const showTechnicalError = svs.myProfile.react.shared.dialogs.showTechnicalError;
const Skeleton = svs.myProfile.react.shared.components.Skeleton;
const toTitleCase = svs.myProfile.react.pages.myInformation.myInformationHelpers.toTitleCase;
const stringFormat = svs.components.tbUtils.stringFormat;

const MyInformationPanel = _ref => {
  let isChangeEmail = _ref.isChangeEmail,
    isChangeMobile = _ref.isChangeMobile;
  const dispatch = ReactRedux.useDispatch();
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    name = _React$useState2[0],
    setName = _React$useState2[1];
  const _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    address = _React$useState4[0],
    setAddress = _React$useState4[1];
  const playerPreferences = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences);
  const playerPreferencesStatus = ReactRedux.useSelector(state => state.playerPreferences.playerPreferencesStatus.status);
  const isPreferenceDataLoaded = ReactRedux.useSelector(state => state.playerPreferences.isPreferenceDataLoaded);
  React.useEffect(() => {
    dispatch(getCustomerBankAccounts());
  }, [dispatch]);
  React.useEffect(() => {
    if (playerPreferencesStatus === FULFILLED || playerPreferencesStatus === REJECTED) {
      if (!playerPreferences.cid) {
        showTechnicalError();
      }
    }
  }, [playerPreferences, playerPreferencesStatus]);
  React.useEffect(() => {
    if (playerPreferencesStatus === FULFILLED) {
      if (playerPreferences !== null && playerPreferences !== void 0 && playerPreferences.name) {
        setName(stringFormat.nameCase("".concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.name, " ").concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.surname)));
      } else {
        setName(React.createElement("i", null, "Dold"));
      }
      if (playerPreferences !== null && playerPreferences !== void 0 && playerPreferences.address) {
        setAddress(toTitleCase("".concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.address, " ").concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.location).toLowerCase()));
      }
    }
  }, [playerPreferences, playerPreferencesStatus]);
  return React.createElement("div", {
    className: "f-center"
  }, !isPreferenceDataLoaded && React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 0
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 4
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 4,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  })), isPreferenceDataLoaded && React.createElement(React.Fragment, null, React.createElement(InfoPair, {
    info: name,
    title: "Namn"
  }), React.createElement(InfoPair, {
    info: playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.cid,
    title: "Kundnummer"
  }), React.createElement(InfoPair, {
    info: address,
    title: "Adress"
  }), React.createElement(EmailCard, {
    isFocused: isChangeEmail
  }), React.createElement(MobileCard, {
    isFocused: isChangeMobile
  }), React.createElement(BankAccountCard, null)));
};
svs.myProfile.react.pages.myInformation.myInformation.MyInformationPanel = MyInformationPanel;

 })(window);